import { DOCUMENT_RELOAD_COMMENTS_REQUEST, DOCUMENT_COUNT_COMMENTS_SUCCESS } from "../types"

const initialState = {
	reloadComments: false,
	doc_counts: {},
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case DOCUMENT_RELOAD_COMMENTS_REQUEST:
			return {
				...state,
				reloadComments: action.payload,
			}

		case DOCUMENT_COUNT_COMMENTS_SUCCESS:
			let counts = state.doc_counts
			counts[action.payload.id] = action.payload.count
			return {
				...state,
				doc_counts: { ...state.doc_counts, ...counts },
			}

		default:
			return state
	}
}
